import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import { NotStartedOutlined } from '@mui/icons-material';
import { useSetAtom } from 'jotai';
import { Link } from 'react-router-dom';

import { VideaButton } from '../../../../common-components/elements/VideaButton/VideaButton';
import routes from '../../../../routes/routes.constants';
import {
  blueBlack400,
  blueUltramarine300,
  greyLight100,
  greyLight600,
} from '../../../../theme/videa-style-tokens';
import { useAppContext } from '../../../../utils/hooks/useAppContext';
import { selectUnifiedIdAtom } from '../../atoms';

const CheckLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: flex;
  margin-left: auto;

  .historical-check {
    &.MuiButton-root {
      box-shadow: none;
      border: 1px solid rgba(0, 0, 0, 0.08);
      background-color: ${greyLight600};
      color: ${blueBlack400};
      text-align: left;
      font-size: 0.75em;
      line-height: 1em;
      max-width: 12em;
      padding: 0.5em 0.75em;
      margin: 0.5em 0.5em;

      &:hover {
        background-color: ${greyLight100};
      }
    }
  }

  .MuiList-root & {
    .historical-check {
      max-width: 100%;
      width: 100%;
      box-sizing: border-box;
      font-size: 0.875em;

      &.MuiButton-root {
        background-color: transparent;
        border-width: 0px;
        border-radius: 0;

        &:hover {
          background-color: ${blueUltramarine300};
          color: white;
        }
      }
    }
  }
`;

export const CheckButton = ({
  unifiedId,
  patientId,
}: {
  unifiedId: string;
  patientId: string;
}) => {
  const context = useAppContext();
  const source = context.app === 'huddle' ? 'huddle' : 'viewer';
  const annotatorUri = `${routes.HISTORICAL}?patientId=${patientId}&source=${source}`;
  const setSelectedUnifiedId = useSetAtom(selectUnifiedIdAtom);

  return (
    <CheckLink to={annotatorUri} className="findings-review">
      <VideaButton
        to={annotatorUri}
        variant="contained"
        startIcon={<NotStartedOutlined />}
        onClick={() => setSelectedUnifiedId(unifiedId)}
        className="historical-check"
        title="Check for un-analyzed historical images"
      >
        <Trans>Check for other images</Trans>
      </VideaButton>
    </CheckLink>
  );
};
